import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [5.31188633047],
    [0.01798475509, 2.9010127305, 38.1330356378],
    [0.01019727662, 0.4858092366, 1.4844727083],
    [0.00124531845, 4.83008090682, 36.6485629295],
    [0.0004206445, 5.41054991607, 2.9689454166],
    [0.00037714589, 6.09221834946, 35.1640902212],
    [0.00033784734, 1.24488865578, 76.2660712756],
    [0.00016482741, 0.00007729261, 491.5579294568],
    [0.00009198582, 4.93747059924, 39.6175083461],
    [0.00008994249, 0.27462142569, 175.1660598002],
    [0.00004216235, 1.98711914364, 73.297125859],
    [0.00003364818, 1.03590121818, 33.6796175129],
    [0.000022848, 4.20606932559, 4.4534181249],
    [0.00001433512, 2.78340432711, 74.7815985673],
    [0.0000090024, 2.07606702418, 109.9456887885],
    [0.00000744996, 3.19032530145, 71.8126531507],
    [0.00000506206, 5.74785370252, 114.3991069134],
    [0.00000399552, 0.34972342569, 1021.2488945514],
    [0.00000345195, 3.46186210169, 41.1019810544],
    [0.00000340323, 3.30369900416, 77.7505439839],
    [0.00000323004, 2.24815188609, 32.1951448046],
    [0.00000306338, 0.49684039897, 0.5212648618],
    [0.00000287322, 4.50523446022, 0.0481841098],
    [0.0000028217, 2.24565579693, 146.594251718],
    [0.00000266605, 4.88932609483, 0.9632078465],
    [0.00000251941, 5.78166597292, 388.4651552382],
    [0.00000244722, 1.24693337933, 9.5612275556],
    [0.00000232887, 2.50459795017, 137.0330241624],
    [0.00000227079, 1.79713054538, 453.424893819],
    [0.00000170404, 3.3239063065, 108.4612160802],
    [0.00000151401, 2.1915309428, 33.9402499438],
    [0.0000015018, 2.99706110414, 5.9378908332],
    [0.00000148295, 0.85948986145, 111.4301614968],
    [0.00000118672, 3.67706204305, 2.4476805548],
    [0.000001093, 2.41599378049, 183.2428146475],
    [0.00000103305, 0.04078966679, 0.2606324309],
    [0.00000103054, 4.40441222, 70.3281804424],
    [0.00000101821, 5.70539236951, 0.1118745846],
];

const VSOP87_L1: Vsop87Element = [
    [38.37687716731],
    [0.00016604187, 4.86319129565, 1.4844727083],
    [0.00015807148, 2.27923488532, 38.1330356378],
    [0.00003334701, 3.6819967602, 76.2660712756],
    [0.0000130584, 3.67320813491, 2.9689454166],
    [0.00000604832, 1.50477747549, 35.1640902212],
    [0.00000178623, 3.45318524147, 39.6175083461],
    [0.00000106537, 2.45126138334, 4.4534181249],
    [0.00000105747, 2.7547932655, 33.6796175129],
    [0.00000072684, 5.48724732699, 36.6485629295],
    [0.00000057355, 1.85767603384, 114.3991069134],
    [0.00000057069, 5.2164980497, 0.5212648618],
    [0.00000035368, 4.51676827545, 74.7815985673],
    [0.00000032216, 5.9041148968, 77.7505439839],
];

const VSOP87_L2: Vsop87Element = [
    [0.00053892649],
    [0.00000295693, 1.85520292248, 1.4844727083],
    [0.00000281251, 1.19084538887, 38.1330356378],
    [0.0000027019, 5.72143228148, 76.2660712756],
    [0.00000023023, 1.21035596452, 2.9689454166],
    [0.00000009057, 4.42544992035, 35.1640902212],
    [0.00000007333, 0.5403330683, 2.4476805548],
    [0.00000005223, 0.67427930044, 168.0525127994],
    [0.00000005201, 3.02338671812, 182.279606801],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000031254],
    [0.00000014541, 1.35337075856, 76.2660712756],
    [0.00000012461, 6.04431418812, 1.4844727083],
    [0.00000011547, 6.11257808366, 38.1330356378],
];

const VSOP87_L4: Vsop87Element = [[0.00000000605, 3.18211885677, 76.2660712756]];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.03088622933, 1.44104372626, 38.1330356378],
    [0.00027780087, 5.91271882843, 76.2660712756],
    [0.00027623609],
    [0.00015448133, 3.50877080888, 39.6175083461],
    [0.0001535549, 2.52123799481, 36.6485629295],
    [0.00001999919, 1.50998669505, 74.7815985673],
    [0.0000196754, 4.37778195768, 1.4844727083],
    [0.00001015137, 3.21561035875, 35.1640902212],
    [0.00000605767, 2.80246601405, 73.297125859],
    [0.00000594878, 2.12892708114, 41.1019810544],
    [0.00000588805, 3.18655882497, 2.9689454166],
    [0.0000040183, 4.16883287237, 114.3991069134],
    [0.00000279964, 1.68165309699, 77.7505439839],
    [0.00000261647, 3.76722704749, 213.299095438],
    [0.00000254333, 3.27120499438, 453.424893819],
    [0.0000020559, 4.25652348864, 529.6909650946],
    [0.00000140455, 3.52969556376, 137.0330241624],
    [0.0000009853, 4.16774829927, 33.6796175129],
    [0.00000067971, 4.66970781659, 71.8126531507],
];

const VSOP87_B1: Vsop87Element = [
    [0.00227279214, 3.8079308987, 38.1330356378],
    [0.0000180312, 1.97576485377, 76.2660712756],
    [0.00001385733, 4.82555548018, 36.6485629295],
    [0.00001073298, 6.08054240712, 39.6175083461],
    [0.00000147903, 3.85766231348, 74.7815985673],
    [0.00000136448, 0.47764957338, 1.4844727083],
    [0.00000070285, 6.18782052139, 35.1640902212],
    [0.00000051899, 5.05221791891, 73.297125859],
];

const VSOP87_B2: Vsop87Element = [
    [0.00009690766, 5.57123750291, 38.1330356378],
    [0.00000078815, 3.62705474219, 76.2660712756],
    [0.00000071523, 0.4547668858, 36.6485629295],
    [0.00000029915, 1.60671721861, 39.6175083461],
];

const VSOP87_B3: Vsop87Element = [[0.00000273423, 1.01688979072, 38.1330356378]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [30.07013206102],
    [0.2706225949, 1.3299945893, 38.1330356378],
    [0.01691764281, 3.25186138896, 36.6485629295],
    [0.00807830737, 5.18592836167, 1.4844727083],
    [0.00537760613, 4.52113902845, 35.1640902212],
    [0.00495725642, 1.57105654815, 491.5579294568],
    [0.0027457197, 1.84552256801, 175.1660598002],
    [0.00135134095, 3.37220607384, 39.6175083461],
    [0.00121801825, 5.79754444303, 76.2660712756],
    [0.00100895397, 0.37702748681, 73.297125859],
    [0.00069791722, 3.79617226928, 2.9689454166],
    [0.00046687838, 5.74937810094, 33.6796175129],
    [0.00024593778, 0.50801728204, 109.9456887885],
    [0.00016939242, 1.59422166991, 71.8126531507],
    [0.00014229686, 1.07786112902, 74.7815985673],
    [0.00012011825, 1.92062131635, 1021.2488945514],
    [0.00008394731, 0.67816895547, 146.594251718],
    [0.000075718, 1.07149263431, 388.4651552382],
    [0.00005720852, 2.59059512267, 4.4534181249],
    [0.00004839672, 1.9068599107, 41.1019810544],
    [0.00004483492, 2.90573457534, 529.6909650946],
    [0.00004420804, 1.74993796503, 108.4612160802],
    [0.0000435379, 0.6798566237, 32.1951448046],
    [0.00004270202, 3.41343865825, 453.424893819],
    [0.0000338093, 0.84810683275, 183.2428146475],
    [0.00002881063, 1.98600105123, 137.0330241624],
    [0.00002878942, 3.67415901855, 350.3321196004],
];

const VSOP87_R1: Vsop87Element = [
    [0.00236338502, 0.70498011235, 38.1330356378],
    [0.00013220279, 3.32015499895, 1.4844727083],
    [0.00008621863, 6.2162895163, 35.1640902212],
    [0.0000270174, 1.88140666779, 39.6175083461],
    [0.00002154735, 2.09431198086, 2.9689454166],
    [0.0000215315, 5.16873840979, 76.2660712756],
    [0.00001603165],
    [0.00001463924, 1.18417031047, 33.6796175129],
    [0.00001135773, 3.91891199655, 36.6485629295],
    [0.0000089765, 5.24122933533, 388.4651552382],
    [0.00000789908, 0.5331548458, 168.0525127994],
    [0.0000076003, 0.02051033644, 182.279606801],
];

const VSOP87_R2: Vsop87Element = [
    [0.00004247412, 5.89910679117, 38.1330356378],
    [0.0000021757, 0.3458182908, 1.4844727083],
    [0.00000163025, 2.2387294713, 168.0525127994],
];

const VSOP87_R3: Vsop87Element = [[0.00000166297, 4.55243893489, 38.1330356378]];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
